import { Backdrop, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import "./styles.scss";

const PREFIX = "Loader";

const classes = {
  backdrop: `${PREFIX}-backdrop`,
};

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  [`&.${classes.backdrop}`]: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "transparent",
  },
}));

function Loader(props) {
  return (
    <StyledBackdrop className={classes.backdrop} open {...props}>
      <CircularProgress color="primary" />
    </StyledBackdrop>
  );
}

export function GradientCircularProgress() {
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="var(--fl-color-primary)" />
            <stop offset="100%" stopColor="var(--fl-color-secondary) " />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress
        sx={{ "svg circle": { stroke: "url(#my_gradient)" } }}
      />
    </React.Fragment>
  );
}

export default Loader;
